import { useContext } from 'react';
import get from 'lodash/get';
import { DeviationTypes, DeviationResourceType } from '../../types/deviation';
import { getDeviationType, getDeviationResourceType, isSimpleDeviation, getCanHavePremiumDownload, isHyped } from '../_helpers';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isExtendedDeviationFullyLoaded } from '../../DeviationPage/redux/helpers';
function getIsEditable(deviation, isMobile) {
    const deviationType = getDeviationType(deviation);
    const canUserEdit = get(deviation, 'extended.canUserEdit', false);
    // Hacky way to sometimes hide the edit button
    if (deviation.legacyTextEditUrl === '#' || deviation.extended && deviation.extended.editUrl === '#') {
        return false;
    }
    switch(deviationType){
        case DeviationTypes.LITERATURE:
        case DeviationTypes.JOURNAL:
            // on mobile, draftjs based lit/journal is not editable
            const textType = get(deviation, 'textContent.html.type');
            if (isMobile && (textType === 'draft' || textType === 'tiptap')) {
                return false;
            }
            return canUserEdit;
        default:
            return canUserEdit;
    }
}
export function useDeviationAttributes(deviation, isOwner) {
    var _deviation_extended, _deviation_extended1, _deviation_author;
    const isMobile = useContext(MobileContext);
    const { isLoggedIn } = useContext(SessionContext);
    const resourceType = getDeviationResourceType(deviation);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const isSimple = isSimpleDeviation(deviation);
    const isReportable = !isOwner && !isSimple;
    const isShareable = deviation.isShareable || isSimple;
    const isGroupSubmittable = !isSimple && (isExtendedLoaded ? !!((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserAddToGroup) : isLoggedIn);
    const isDeletable = isExtendedLoaded ? !!((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.canUserDelete) : isOwner;
    const hasMoreActions = isShareable || isReportable;
    const hasNft = deviation.hasNft || false;
    return {
        hasFlag: !!deviation.dailyDeviation || !!isHyped(deviation),
        hasMoreActions,
        isCommentable: !!deviation.isCommentable,
        isFavouritable: !isSimple && !isOwner,
        isGroupSubmittable,
        isDownloadable: !!deviation.isDownloadable,
        isAdoptable: !!deviation.isAdoptable,
        isPurchasable: !!deviation.isPurchasable,
        isShareable,
        isReportable,
        canHavePremiumDownload: getCanHavePremiumDownload(deviation),
        isEditable: getIsEditable(deviation, isMobile === true),
        isDeletable,
        isBackgroundEditable: !!deviation.isBackgroundEditable,
        isAuthorCommissionable: ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.type) !== 'banned',
        isCoreBadgeAwardable: !isOwner && resourceType === DeviationResourceType.ART,
        isExtendedLoaded,
        hasNft
    };
}

//# sourceMappingURL=useDeviationAttributes.js.map